<template>
  <div id="form-template">
    <h4>实名认证</h4>
    <div class="mg">
      根据中国海关要求需要填写支付人身份证信息，请确保谁支付下面就填写谁的信息，填写错误会导致清关失败！
    </div>
    <div class="form" style="padding-bottom: 0; display: none">
      <SfSelect
        v-if="false"
        :label="$t('ID_Type')"
        :required="true"
        :valid="idType !== ''"
        :disabled="false"
        :errorMessage="$t('ID_Type_Error')"
        class="form__element form__element--half"
        v-bind:class="{ 'sf-selectTop': idType === '' }"
        placeholder=""
        v-model="idType"
        @input="idTypeChange"
      >
        <SfSelectOption value="1">身份证</SfSelectOption>
        <SfSelectOption value="2">护照</SfSelectOption>
        <SfSelectOption value="3">其他</SfSelectOption>
      </SfSelect>
    </div>
    <form class="form" style="padding-top: 0;margin-bottom: 0;padding-bottom:0;gap: 1rem;display: flex;flex-direction: column;">
      <div class="sf-property--full-width property emailRow">
        <SfInput
          v-model="idName"
          :label="$t('ID_Name')"
          name="idName"
          class="form__element form__element--half emailInput"
          required
          :valid="idNameBlur || valididName(idName)"
          :error-message="$t('ID_Name_Error')"
          @blur="idNameBlur = false"
          @change="setIdName"
        />
      </div>
      <div class="sf-property--full-width property emailRow">
      <SfInput
        v-model="idNumber"
        :label="$t('ID_Number')"
        name="idNumber"
        class="form__element form__element--half emailInput"
        required
        :valid="idNumberBlur || valididNumber(idNumber)"
        :error-message="$t('ID_Number_Error')"
        @blur="idNumberBlur = false"
        @change="setIdNumber"
      />
      </div>
      <!-- <div class="form__action">
        <SfButton type="submit" @click.prevent="submit">Submit</SfButton>
        <SfButton
          class="sf-button--text form__action-button form__action-button--secondary"
          @click="reset"
          >Reset</SfButton
        >
      </div> -->
    </form>
  </div>
</template>
<script>
import {
  SfInput,
  SfButton,
  SfHeading,
  SfSelect
} from '@storefront-ui/vue';
import { usePreviewOrderStore } from '~/stores/previewOrder';
import { ref } from '@nuxtjs/composition-api';
export default {
  name: 'IdCard',
  components: {
    SfButton,
    SfInput,
    SfHeading,
    SfSelect
  },
  setup() {
    const previewOrderStore = usePreviewOrderStore();
    const valid = ref(false);
    const submitted = ref(false);
    const idName = ref(previewOrderStore?.IdCard?.id_name || '');
    const idNameBlur = ref(false);
    const idNumber = ref(previewOrderStore?.IdCard?.id_number || '');
    const idType = ref(previewOrderStore?.IdCard?.id_type || '1');
    previewOrderStore.setIdType('1');
    const idNumberBlur = ref(false);
    const valididName = (idName) => {
      return idName?.length >= 2;
    };
    const valididNumber = (idNumber) => {
      return idNumber?.length === 18;
    };

    const validate = () => {
      if (
        valididName(idName.value) &&
        valididNumber(idNumber.value)
      ) {
        valid.value = true;
      }
    }
    const setIdName = () => {
      // console.log('setIdName', idName.value, previewOrderStore.IdCard);
      previewOrderStore.setIdName(idName.value);
    };
    const setIdNumber = () => {
      previewOrderStore.setIdNumber(idNumber.value);
    };
    const idTypeChange = () => {
      previewOrderStore.setIdType(idType.value);
      // console.log('idTypeChange', idType.value);
    };
    const getIdCard = () => {
      return { idName: idName.value, idNumber: idNumber.value, idType: idType.value };
    };
    const checkedValid = () => {
      validate();
      if (valid.value) {
        // context.emit('checkedValid', true)
        return true;
      } else {
        // context.emit('checkedValid', false)
        return false;
      }
    }
    return {
      valid,
      submitted,
      idName,
      idNameBlur,
      idNumber,
      idNumberBlur,
      setIdName,
      setIdNumber,
      valididName,
      valididNumber,
      idType,
      idTypeChange,
      checkedValid,
      getIdCard
    };
  }
};
</script>
<style lang="scss">
.sf-select__dropdown {
  border-bottom: 1px solid #1a1a1a;
}
.sf-select__label {
  height: auto;
}
.sf-select {
  /* --input-label-font-size: var(--font-size--xs);
      height: auto;
    min-height: var(--input-height, calc(var(--spacer-base) + var(--spacer-2xs) + var(--input-label-font-size, var(--font-size--lg)))); */
  display: flex;
  flex-direction: column;
}
.form {
  .sf-selectTop select {
    margin: var(--input-padding, var(--spacer-lg) 0 var(--spacer-xs) 0);
  }
}
</style>
<style lang="scss" scoped>
@import '~@storefront-ui/vue/styles';
#form-template {
  box-sizing: border-box;
  // padding: 0 var(--spacer-sm);
  @include for-desktop {
    // padding: 0 var(--spacer-sm);
    max-width: 870px;
    margin: 0 auto;
  }

  @include for-mobile {
    // padding: 0 var(--spacer-sm);
    max-width: 100%;
    margin: 0 auto;
  }
}
.mg {
  margin-top: 10px;
  margin-bottom: 20px;
}
.form {
  padding: 0 0 var(--spacer-sm) 0;
  &__group {
    display: flex;
    align-items: flex-start;
  }
  &__action-button {
    &:first-child {
      margin: var(--spacer-sm) 0 0 0;
    }
    &--secondary {
      margin: var(--spacer-sm) 0 var(--spacer-sm) var(--spacer-base);
    }
  }
  &__button {
    --button-width: 100%;
  }
  @include for-mobile {
    #message {
      padding: var(--spacer-sm);
      box-sizing: border-box;
      margin: 1rem 0 1rem 0;
      width: 100%;
    }
    &__element--range {
      margin: var(--spacer-sm) 0 var(--spacer-2xl);
    }
    .sf-button {
      --button-width: auto;
      margin-top: var(--spacer-xs);
    }
  }
  @include for-desktop {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin: 0 var(--spacer-2xl) 0 0;
    &:last-of-type {
      margin: 0 calc(var(--spacer-2xl) - var(--spacer-sm)) 0 0;
    }
    &__element {
      margin: 0 0 var(--spacer-sm) 0;
      flex: 0 0 100%;
      &--half {
        flex: 1 1 50%;
        &-even {
          padding: 0 0 0 var(--spacer-xl);
        }
      }
      &--range {
        margin: var(--spacer-xl) var(--spacer-base) var(--spacer-2xl);
      }
    }
    &__action {
      flex: 0 0 100%;
      display: flex;
    }
    &__button {
      --button-width: auto;
    }
  }
}
</style>
